module.exports = __webpack_public_path__ + "img/VH.ce168395.png";